import React from 'react';
import Title from '../title';
import Loading from '../loading';
import $ from "jquery";
import Server from '../../functions/server';
import { Grid, Button, Dropdown, Card, Input } from 'semantic-ui-react';
import './stockinfo.css';
import View from './view';
import ReadCookie from '../../functions/readcookies';
import Permission from '../../functions/permission';

class Info extends React.Component {

  state = {
    load: false,
    message: '',
    data: [],
    brandOption: [],
    brandOptions: [],
    selectedBranch: '',
    selectedBrand: 'ALL',
    search: '', menuPermission: [],
    pageNumber: 1
  }

  componentDidMount() {
    
    this.menuControl();
  }

  menuControl() {
    let menuPermission = Permission('stock-info', this.props.menus);
    if (menuPermission.view) {
      this.getBrands();
      this.getBranch();
    }
    this.setState({ menuPermission })
  }

  getBranch() {
    let data = (ReadCookie("branch"));
    if (data == 0) {
      this.setState({ permissionError: 'You not have permission to access this menu!!!' })
    }
    else {
      let branchId;
      for (var i = 0; i < data.length; i++) {
        branchId = data[i].branch_id;
      }
      this.setState({ selectedBranch: branchId })
    }
  }

  getBrands() {
    let context = this;
    context.setState({ load: true, message: 'Getting Branchs' });
    $.ajax({
      type: 'POST',
      url: Server() + 'stockinfo/getallbrands.php',
      success: function(data) {
        try {
          data = JSON.parse(data);
          context.setAllBrand(data);
        } catch (e) { alert('Error');
          context.setState({ load: false });
        }
      },
      error: function(e) {
        alert('Try again!!')
        context.setState({ load: false });
      }
    });
  }

  setAllBrand(data) {
    var x = [];
    x.push({key: 'ALL', text: 'ALL', value: 'ALL'});
    data.map((y) => {
      x.push({key: y.brand_name, text: y.brand_name, value: y.id});
    });
    this.setState({ brandOptions: x, load: false });
  }

  render() {
    return (
      <div>
         <Title title={'Stock Info'} openDrawer={this.props.openDrawer} />
        { this.state.menuPermission.view  ?
           (
             <div>
               <div style={{display: this.state.stockinfo}}>
                 <View menuPermission={this.state.menuPermission} branch={this.state.selectedBranch} brandOptions={this.state.brandOptions} />
               </div>
             </div>
           ):
           (
             <div>
               <center>You are not allow to access this menu!!!</center>
             </div>
           )
        }
      </div>
    );
  }
}

export default Info;
